import { BodyTypeLabels, FitTypeLabels, UserDetails } from '../types/contexts/userContext';
import { AllTShirtMeasuresMandatory, TeeMeasureLabel } from '../types/databaseTables/idealteemeasures';
import { logAdminExternal } from '../utils/logging';

export interface UserDetailsActionUpdateFromGenerator {
    type: 'update from generator',
    payload: {
        idealGarmentMeasurements: AllTShirtMeasuresMandatory,
        height: number, weight: number, fitType: FitTypeLabels, bodyType: BodyTypeLabels
    }
}

interface IdealMeasuresFromHistoryLog {
    type: "update from history log",
    payload: {
        idealMeasures: AllTShirtMeasuresMandatory,
        // eslint-disable-next-line camelcase
        idealteemeasures_id: number,
    },
}

export interface UserDetailsActionUpdateFromIdealMeasuresPage {
    type: "update from ideal measurements",
    payload: AllTShirtMeasuresMandatory,
}


export interface UserDetailsActionUpdateMeasureWeightings {
    type: "update measure weightings",
    payload: {
        fitScoreWeightings: AllTShirtMeasuresMandatory
    },
}

export interface UserDetailsActionUpdateSettings {
    type: 'update settings',
    payload: {
        unitcm: 1 | 2.57
    },
}

export type UserDetailsAction = UserDetailsActionUpdateFromGenerator | IdealMeasuresFromHistoryLog | UserDetailsActionUpdateFromIdealMeasuresPage | UserDetailsActionUpdateMeasureWeightings | UserDetailsActionUpdateSettings;



export function userDetailsReducer(initialState: UserDetails, action: UserDetailsAction): UserDetails {
    const returnState = { ...initialState };
    const currentTimestamp = new Date().toUTCString()
    switch (action.type) {
        case "update from generator": {
            returnState.timestamps.idealGarmentMeasurements = currentTimestamp;
            returnState.idealGarmentMeasurements = action.payload.idealGarmentMeasurements;
            returnState.userMeasurements.height = action.payload.height;
            returnState.bodyInfo.weight = action.payload.weight;
            returnState.bodyInfo.bodyType = action.payload.bodyType;
            returnState.bodyInfo.fitType = action.payload.fitType;
            break;
        }
        case "update from history log": {
            returnState.timestamps.idealGarmentMeasurements = currentTimestamp;
            returnState.idealGarmentMeasurements = action.payload.idealMeasures;
            returnState.idealteemeasureslog_id = action.payload.idealteemeasures_id
            break;
        }
        case "update from ideal measurements": {
            returnState.timestamps.idealGarmentMeasurements = currentTimestamp;
            Object.keys(returnState.idealGarmentMeasurements).forEach(thisMeasureLabel => {
                returnState.idealGarmentMeasurements[thisMeasureLabel as TeeMeasureLabel] = action.payload[thisMeasureLabel as TeeMeasureLabel] || returnState.idealGarmentMeasurements[thisMeasureLabel as TeeMeasureLabel]
            })
            // returnState.idealGarmentMeasurements = action.payload;
            break;
        }
        case "update measure weightings": {
            returnState.fitScoreWeightings = action.payload.fitScoreWeightings;
            break;
        }
        case "update settings": {
            returnState.unitcm = action.payload.unitcm;
            break;
        }
        default:
            logAdminExternal({
                status: "userDetailsReducer returning default value"
            })
            return initialState

    }
    localStorage.setItem("userDetails", JSON.stringify(returnState));    
    return returnState
}